import { Avatar, Box } from "@material-ui/core";
import { stringAvatar } from "utils/contacts/display";
import { SxProps } from "@material-ui/system";

type ContactTableAvatarProps = {
  sx?: SxProps;
  badgeSize?: number;
  avatarUrl?: string;
  avatarSize: number;
  callerFullName: string;
  crmIsHot?: boolean; // canonical hot-lead flag (CRM v2) — the only source for the flame badge
};

export function ContactTableAvatar({
  sx,
  badgeSize,
  avatarUrl,
  avatarSize,
  callerFullName,
  crmIsHot
}: ContactTableAvatarProps): JSX.Element {
  const { sx: avatarStyle, children: avatarText } = stringAvatar(callerFullName);

  const isHotCustomer = crmIsHot === true;

  return (
    <Box sx={{ position: "relative" }}>
      <Avatar
        sx={{
          ...avatarStyle,
          ...sx,
          width: avatarSize,
          height: avatarSize,
          color: "white"
        }}
        src={avatarUrl}
      >
        {avatarText}
      </Avatar>
      {isHotCustomer && (
        <Box
          sx={{
            position: "absolute",
            bottom: -8,
            right: -8,
            fontSize: badgeSize
          }}
        >
          🔥
        </Box>
      )}
    </Box>
  );
}
